import React from 'react';
import classNames from 'classnames/bind';
import { TableBody } from "../../../TableBody";
import { TableCell } from "../../../TableCell";
import { TableFilterButton } from "../../../TableFilterButton";
import { TableHead } from "../../../TableHead";
import { TableHeadCell } from "../../../TableHeadCell";
import { TableRow } from "../../../TableRow";
import Title from "../../../Title";
import styles from './TableWithProps.css';
var cx = classNames.bind(styles);
export var TableWithProps = function TableWithProps(_ref) {
  var rows = _ref.rows,
      columns = _ref.columns,
      _ref$withHeader = _ref.withHeader,
      withHeader = _ref$withHeader === void 0 ? true : _ref$withHeader;
  return /*#__PURE__*/React.createElement(React.Fragment, null, withHeader && /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, columns.map(function (column, idx) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement(TableHeadCell, {
        key: idx
      }, /*#__PURE__*/React.createElement("div", {
        className: cx('head-cell')
      }, /*#__PURE__*/React.createElement(Title, {
        level: 5,
        as: "div"
      }, /*#__PURE__*/React.createElement(React.Fragment, null, column.renderColumn ? column.renderColumn(column.title) : column.title)), column.onFilter && /*#__PURE__*/React.createElement(TableFilterButton, {
        onClick: column.onFilter
      })))
    );
  }))), /*#__PURE__*/React.createElement(TableBody, null, rows.map(function (row, rowIndex) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement(TableRow, {
        key: rowIndex
      }, columns.map(function (column, columnIndex) {
        return (
          /*#__PURE__*/
          // eslint-disable-next-line react/no-array-index-key
          React.createElement(TableCell, {
            key: columnIndex
          }, column.renderRow ? column.renderRow(column, row) : // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          row[column.key])
        );
      }))
    );
  })), /*#__PURE__*/React.createElement(TableBody, null));
};